import React from 'react';
import { Award, MapPin } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://customer-assets.emergentagent.com/job_ice-maestro/artifacts/gjcmroh4_VASSILEVA%20%281%29.jpg"
          alt="Hristina Vassileva Figure Skating"
          className="w-full h-full object-contain object-center bg-slate-800"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/85 via-slate-900/50 to-slate-900/30"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 z-10 pt-20">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-6">
            <Award className="w-4 h-4 text-amber-400" />
            <span className="text-white text-sm font-medium">6x Bulgarian National Champion</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Elite Coaching for the
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-sky-300 to-sky-100">
              Next Generation
            </span>
            of Champions
          </h1>

          {/* Description */}
          <p className="text-xl text-slate-200 mb-8 leading-relaxed">
            International figure skating coach and choreographer combining European discipline with modern training methods. Transform your skating journey with expert guidance from a former international competitor.
          </p>

          {/* Location Badge */}
          <div className="flex items-center space-x-2 text-slate-300 mb-10">
            <MapPin className="w-5 h-5 text-sky-400" />
            <span className="text-lg">Based in Sofia, Bulgaria</span>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              onClick={scrollToContact}
              size="lg"
              className="bg-sky-600 hover:bg-sky-700 text-white text-lg px-8 py-6 shadow-xl hover:shadow-2xl transition-all duration-300"
            >
              Start Your Journey
            </Button>
            <Button
              onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })}
              size="lg"
              variant="outline"
              className="bg-white/10 backdrop-blur-sm border-white/30 text-white hover:bg-white/20 text-lg px-8 py-6"
            >
              Learn More
            </Button>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent z-10"></div>
    </section>
  );
};

export default Hero;